import React from "react";
import { deepCompare, validateEmail, deepClone, encodeHandler } from "utils";
import {
  saveBackupPlansSettingStart,
  createNewBackupPlanStart
} from "./../../../ducks/actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { SPopupContext } from "App/common/hoc/SlidingPopup";
import { LayoutContext } from "App/common/hoc/Layout";
import { VALIDATION } from "consts";
import { NOTIFICATION_STATUS } from "./../../../../componentsConfig";
import { NOTIFICATIONS } from "./../../../../../consts";

function BackupPlanFooter(props) {
  const { lState, lMethods } = React.useContext(LayoutContext);
  const [changed, setChanged] = React.useState(
    lState.slidingPopup.params.isNew ? true : false
  );
  const { sPopupState, sPopupMethods } = React.useContext(SPopupContext);
  const sPopupRef = React.useRef();

  /*****************************Handling  popup using enter key ***************************/
  React.useEffect(() => {
    sPopupRef.current = sPopupState;

    const handleKeyDown = e => {
      if (
        e.key === "Enter" &&
        sPopupRef.current.popup.show &&
        sPopupRef.current.popup.alertName === "saveOrDiscardChanges"
      ) {
        sPopupRef.current.popup.params.execute();
      }
    };
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.addEventListener("keydown", handleKeyDown);
    };
  }, [sPopupState]);
  React.useEffect(() => {
    if (props.planSettings.maxClientsExceeded) {
      sPopupMethods.showNotify({
        msg: NOTIFICATIONS.enableMachine.computerLimit,
        status: "warning",
        upgrade: true
      });
    } else {
      sPopupMethods.closeNotify();
    }
  }, [props.planSettings]);

  function update() {
    if (
      (!deepCompare(props.planSettings, props.cacheSettings) ||
        lState.slidingPopup.params.isNew) &&
      props.planSettings.planName !== ""
    ) {
      let settings = {};
      if (lState.slidingPopup.params.isNew) {
        settings = { ...props.planSettings };
        //encode plan name
        settings.planName = encodeHandler(settings.planName);
      } else {
        if (
          !deepCompare(props.planSettings.cleanup, props.cacheSettings.cleanup)
        ) {
          settings.cleanup = props.planSettings.cleanup;
        }
        if (
          !deepCompare(
            props.planSettings.emailNotification,
            props.cacheSettings.emailNotification
          )
        ) {
          let emailNotification = { ...props.planSettings.emailNotification };
          if (props.planSettings.emailNotification.emails.length > 0) {
            emailNotification.enable = true;
          } else {
            emailNotification.enable = false;
          }
          settings.emailNotification = emailNotification;
        }
        if (
          !deepCompare(
            props.planSettings.scheduleInfo,
            props.cacheSettings.scheduleInfo
          )
        ) {
          settings.scheduleInfo = props.planSettings.scheduleInfo;
        }
        if (
          !deepCompare(
            props.planSettings.performance,
            props.cacheSettings.performance
          )
        ) {
          settings.performance = props.planSettings.performance;
        }
        if (
          !deepCompare(
            props.planSettings.encryption,
            props.cacheSettings.encryption
          )
        ) {
          settings.encryption = props.planSettings.encryption;
        }
        if (
          !deepCompare(
            props.planSettings.cutOffTime,
            props.cacheSettings.cutOffTime
          )
        ) {
          settings.cutOffTime = props.planSettings.cutOffTime;
        }
        if (props.planSettings.backupType !== props.cacheSettings.backupType) {
          settings.backupType = props.planSettings.backupType;
        }
        if (props.planSettings.planName !== props.cacheSettings.planName) {
          //encode backup planName
          settings.planName = encodeHandler(props.planSettings.planName);
        }
        if (props.planSettings.planType !== props.cacheSettings.planType) {
          settings.planType = props.planSettings.planType;
        }
        if (props.planSettings.status !== props.cacheSettings.status) {
          settings.status = props.planSettings.status;
        }
        if (
          props.planSettings.backupSource !== props.cacheSettings.backupSource
        ) {
          settings.backupSource = +props.planSettings.backupSource;
        }
        settings.devices = props.planSettings.devices;
        settings.planId = props.planSettings.planId;
      }
      //append logs
      appendLogs(settings, props.planSettings, props.cacheSettings);
      if (lState.slidingPopup.params.isNew) {
        props.createNewBackupPlanStart(settings);
      } else {
        props.saveBackupPlansSettingStart(settings);
      }
    }
  }

  function appendLogs(settings, plan, cache) {
    if (plan.devices.length === 0 && cache.devices.length === 0) {
      return;
    } else {
      let pnsData = [];
      let log = {
        mode: "backupPlan",
        params: {
          planName: plan.planName,
          action: "editSettings",
          devices: []
        }
      };
      for (let i = 0; i < plan.devices.length; i++) {
        if (
          !JSON.stringify(cache.devices).includes(plan.devices[i].clientUUID)
        ) {
          log.params.devices.push({
            clientUUID: plan.devices[i].clientUUID,
            type: "added"
          });
          pnsData.push(plan.devices[i].clientUUID);
        } else {
          let p = deepClone(plan);
          let c = deepClone(cache);
          delete p.devices;
          delete p.log;
          delete p.emailNotification.current;
          delete c.devices;
          delete c.log;
          if (!deepCompare(p, c)) {
            log.params.devices.push({
              clientUUID: plan.devices[i].clientUUID,
              type: "settingsChanged"
            });
            pnsData.push(plan.devices[i].clientUUID);
          }
        }
      }
      for (let i = 0; i < cache.devices.length; i++) {
        if (
          !JSON.stringify(plan.devices).includes(cache.devices[i].clientUUID)
        ) {
          log.params.devices.push({
            clientUUID: cache.devices[i].clientUUID,
            type: "removed"
          });
          pnsData.push(cache.devices[i].clientUUID);
        }
      }
      settings.log = JSON.stringify(log);
      settings.pnsData = pnsData;
    }
  }

  function validateAll() {
    const validation = {
      status: true,
      msg: "",
      params: {}
    };
    validateEmailSettings(validation);
    validateBackupSchedule(validation);
    sPopupMethods.showValidation(validation);
    return validation.status;
  }

  function validateEmailSettings(validation) {
    let emailsList = [];
    emailsList.push(props.planSettings.emailNotification.current);
    let correctEmails = [];
    let wrongEmails = [];
    let duplicateEmails = [];
    for (let i = 0; i < emailsList.length; i++) {
      if (emailsList[i]) {
        if (!validateEmail(emailsList[i].replace(" ", ""))) {
          validation.status = false;
          validation.params = {
            ...validation.params,
            ...{
              email: {
                show: true,
                msg: VALIDATION.backupSettings.email.valid
              }
            }
          };
          wrongEmails.push(emailsList[i].replace(" ", ""));
        } else {
          if (
            props.planSettings.emailNotification.emails.includes(
              emailsList[i].replace(" ", "")
            ) ||
            correctEmails.includes(emailsList[i].replace(" ", ""))
          ) {
            duplicateEmails.push(emailsList[i].replace(" ", ""));
          } else correctEmails.push(emailsList[i].replace(" ", ""));
        }
      }
      wrongEmails.push.apply(wrongEmails, duplicateEmails);
      let tempPlan = { ...props.planSettings };
      tempPlan.emailNotification.current = wrongEmails.join(",");
      tempPlan.emailNotification.emails = tempPlan.emailNotification.emails.concat(
        correctEmails
      );

      props.setPlanSettings(tempPlan);

      if (duplicateEmails.length > 0) {
        validation.status = false;
        validation.params = {
          ...validation.params,
          ...{
            email: {
              show: true,
              msg: VALIDATION.backupSettings.email.duplicate
            }
          }
        };
      }
    }
    if (props.planSettings.emailNotification.smtpSettings.isEnabled) {
      if (
        props.planSettings.emailNotification.emails.length > 0 ||
        props.planSettings.emailNotification.currentEmail.trim() !== ""
      ) {
        if (
          props.planSettings.emailNotification.smtpSettings.serverName.trim() ===
            "" ||
          props.planSettings.emailNotification.smtpSettings.serverName.length <
            3
        ) {
          validation.status = false;
          validation.params = {
            ...validation.params,
            ...{
              servername: {
                check: true,
                msg: VALIDATION.backupSettings.smtp.servername
              }
            }
          };
        }
        if (
          props.planSettings.emailNotification.smtpSettings.userName.trim() ===
            "" ||
          props.planSettings.emailNotification.smtpSettings.userName.length < 3
        ) {
          validation.status = false;
          validation.params = {
            ...validation.params,
            ...{
              username: {
                check: true,
                msg: VALIDATION.backupSettings.smtp.username
              }
            }
          };
        }
        if (
          props.planSettings.emailNotification.smtpSettings.password.trim() ===
            "" ||
          props.planSettings.emailNotification.smtpSettings.password.length < 4
        ) {
          validation.status = false;
          validation.params = {
            ...validation.params,
            ...{
              password: {
                check: true,
                msg: VALIDATION.backupSettings.smtp.password
              }
            }
          };
        }
        if (
          props.planSettings.emailNotification.smtpSettings.port === "" ||
          props.planSettings.emailNotification.smtpSettings.port < 1 ||
          props.planSettings.emailNotification.smtpSettings.port > 65535
        ) {
          validation.status = false;
          validation.params = {
            ...validation.params,
            ...{
              port: {
                check: true,
                msg: VALIDATION.backupSettings.smtp.port
              }
            }
          };
        }
      }
    }
  }

  function validateBackupSchedule(validation) {
    if (
      props.planSettings.scheduleInfo.type ===
        props.enums.ScheduleType.CUSTOM &&
      props.planSettings.scheduleInfo.weekDays.length === 0
    ) {
      sPopupMethods.showNotify({
        msg: VALIDATION.backupSettings.schedule.emptyWeekdays,
        status: NOTIFICATION_STATUS.warning.name
      });
      validation.status = false;
      validation.params = {
        ...validation.params,
        ...{
          emptyWeekdays: {
            check: true,
            msg: VALIDATION.backupSettings.schedule.emptyWeekdays
          }
        }
      };
    }
  }

  function done() {
    if (validateAll()) {
      props.setOriginalSettings(props.planSettings);
      props.setPlanSettings(props.planSettings);
      props.switchPanel("summary", "", {
        planSettings: props.planSettings,
        setPlanSettings: props.setPlanSettings
      });
      sPopupMethods.disableClose(true, {});
      sPopupMethods.closePopup();
    }
  }

  function cancel() {
    if (changed) {
      sPopupMethods.openPopup("saveOrDiscardChanges", {
        disable: props.planSettings.maxClientsExceeded,
        execute: () => {
          sPopupMethods.closePopup();
          if (!props.isSummary && validateAll()) done();
        },
        cancel: true,
        secondExecute: () => {
          if (props.isSummary) {
            lMethods.closeSlidingPopup();
          } else {
            props.setPlanSettings(props.originalSettings);
            props.switchPanel("summary", "", {
              planSettings: props.originalSettings
            });
            sPopupMethods.disableClose(true, {});
            sPopupMethods.closePopup();
          }
        }
      });
    } else {
      if (props.isSummary) {
        lMethods.closeSlidingPopup();
      } else {
        props.setPlanSettings(props.originalSettings);
        props.switchPanel("summary", "", {
          planSettings: props.originalSettings
        });
        sPopupMethods.disableClose(true, {});
        sPopupMethods.closePopup();
      }
    }
  }

  React.useEffect(() => {
    if (
      sPopupState.notify.params &&
      sPopupState.notify.params.msg !==
        NOTIFICATIONS.enableMachine.computerLimit
    ) {
      const timer = setTimeout(() => {
        sPopupMethods.closeNotify();
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [sPopupState.notify.show]);

  React.useEffect(() => {
    if (
      !props.settings.loading &&
      props.settings.updated &&
      !props.cacheSettings
    ) {
      lMethods.closeSlidingPopup();
    } else if (
      !props.settings.loading &&
      props.settings.createdNewBackup &&
      !props.cacheSettings
    ) {
      lMethods.closeSlidingPopup();
    }
  }, [props.settings, props.cacheSettings]);

  React.useEffect(() => {
    const tempPlan = deepClone(props.planSettings);
    let maxClientsExceeded = tempPlan.maxClientsExceeded;
    delete tempPlan.maxClientsExceeded;
    if (
      !deepCompare(tempPlan, props.cacheSettings) &&
      props.planSettings.planName != ""
    ) {
      setChanged(true);
      sPopupMethods.disableClose(false, {
        display: discardTo => {
          if (discardTo === "backToSummaryDefaultSave") {
            done();
          } else {
            sPopupMethods.openPopup("saveOrDiscardChanges", {
              disable: maxClientsExceeded,
              execute: () => {
                sPopupMethods.closePopup();
                if (props.isSummary) {
                  update();
                } else done();
              },
              cancel: true,
              secondExecute: () => {
                if (discardTo === "layout") lMethods.closeSlidingPopup();
                else if (discardTo === "backToSummary") {
                  props.setPlanSettings(props.originalSettings);
                  props.switchPanel("summary", "", {
                    planSettings: props.originalSettings
                  });
                  sPopupMethods.disableClose(true, {});
                  sPopupMethods.closePopup();
                } else {
                  lMethods.closeSlidingPopup();
                }
              }
            });
          }
        }
      });
    } else {
      setChanged(false);
      if (!sPopupState.disableClose.close) {
        sPopupMethods.disableClose(true, {});
      }
    }
  }, [props.planSettings]);

  // React.useEffect(() => {
  //   if (props.notification && props.notification.backupPlan) {
  //     lMethods.closeSlidingPopup();
  //   }
  // }, [props.notification]);

  function footerSubmitButton() {
    if (changed) {
      if (props.isSummary) {
        if (!props.planSettings.maxClientsExceeded) {
          delete props.planSettings.maxClientsExceeded;
          update();
        }
      } else done();
    } else if (lState.slidingPopup.params.isNew) {
      if (props.isSummary) {
        update();
      } else {
        done();
      }
    }
  }

  return (
    <div className="slider_content_footer">
      <div className="slider_summary_btns">
        <div className="slider_summary_btns__inner">
          <div className="backup_image_btns just_flex">
            <div
              className={[
                "slider_btn btn_primary",
                (changed ||
                  (lState.slidingPopup.params.isNew && !props.isSummary) ||
                  (lState.slidingPopup.params.isNew &&
                    props.planSettings.planName !== "")) &&
                !props.planSettings.maxClientsExceeded
                  ? ""
                  : "btn_disable"
              ].join(" ")}
              onClick={() => footerSubmitButton()}
            >
              {props.isSummary
                ? lState.slidingPopup.params.isNew
                  ? "Create"
                  : "Update"
                : "Done"}
            </div>
            <div className="slider_btn btn_cancel" onClick={cancel}>
              Cancel
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    cacheSettings: state.backupPlan.cachePlanSettings,
    enums: state.common.enums,
    backupPlanSettings: state.backupPlan.backupPlanSettings,
    settings: state.backupPlan.settings,
    backupPlans: state.backupPlan.backupPlans,
    notification: state.common.notification
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      saveBackupPlansSettingStart,
      createNewBackupPlanStart
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(BackupPlanFooter);
